module.exports = {
        srcSet: __webpack_public_path__ + "assets/images/board/corner-top-left-50.png"+" 50w",
        images: [{path: __webpack_public_path__ + "assets/images/board/corner-top-left-50.png",width: 50,height: 50}],
        src: __webpack_public_path__ + "assets/images/board/corner-top-left-50.png",
        toString: function(){return __webpack_public_path__ + "assets/images/board/corner-top-left-50.png"},
        
        width: 50,
        height: 50
      }